export const environment = {
  production: true,
  apiUrl:"https://rowadalasrshipping.com/ATAdmin/"
};
